/**
 * Fashion Mes – Featured Collection Randomizer
 * Theme: Pillar (Pillar - Updated)
 *
 * HOW TO INSTALL — follow the step-by-step guide below.
 *
 * WHAT THIS DOES:
 * Every time a visitor loads your homepage, the product cards inside
 * every Featured Collection section are shuffled into a random order.
 * The shuffle happens instantly (before the visitor sees anything), so
 * there is no visible "jumping" of products.
 */
 
(function () {
  /**
   * Fisher-Yates shuffle — the standard, perfectly-random algorithm.
   * Takes an array and returns it in a new random order.
   */
  function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }
 
  /**
   * Shuffles the product cards inside one product grid container.
   * Works with both the carousel (swiper) layout and the plain grid layout.
   *
   * @param {Element} grid  – the .featured-collection__items element
   */
  function shuffleGrid(grid) {
    // Collect all direct child columns (each one holds one product card)
    var columns = Array.from(grid.children);
 
    // If the section has a banner card (image card) as the FIRST column,
    // we keep it pinned in place and only shuffle the product cards after it.
    var firstIsBanner = (
      columns.length > 0 &&
      columns[0].querySelector('.card-image') !== null
    );
 
    var pinned   = firstIsBanner ? [columns[0]] : [];
    var toShuffle = firstIsBanner ? columns.slice(1) : columns;
 
    if (toShuffle.length < 2) return; // nothing to shuffle
 
    shuffleArray(toShuffle);
 
    // Re-attach every column in the new order.
    // Using appendChild moves each node — no cloning needed.
    pinned.concat(toShuffle).forEach(function (col) {
      grid.appendChild(col);
    });
  }
 
  /**
   * Main function — finds every featured collection grid on the page
   * and shuffles it.
   */
  function randomizeFeaturedCollections() {
    // .featured-collection__items  →  the product grid in your Pillar theme
    var grids = document.querySelectorAll('.featured-collection__items');
 
    grids.forEach(function (grid) {
      shuffleGrid(grid);
    });
  }
 
  /**
   * Run as early as possible so the shuffle happens before the browser
   * paints the page.  'DOMContentLoaded' fires when the HTML is fully
   * parsed but before images load — exactly the right moment.
   *
   * The Pillar theme also uses a Swiper carousel.  We run BEFORE Swiper
   * initialises, so Swiper picks up the already-shuffled order. ✓
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', randomizeFeaturedCollections);
  } else {
    // Page was already parsed (e.g. script runs late) — shuffle immediately.
    randomizeFeaturedCollections();
  }
})();